/**
 * @file jsbmedia.js
 */

/**
 * @description Google Analytics
 * Copy and paste it in the code of every page of your website, immediately 
 * after the <head> element.
 */
export function jsbGtags() {
    $.getScript("https://www.googletagmanager.com/gtag/js?id=G-VE28PHYRLV", () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());

        gtag('config', 'G-VE28PHYRLV');
    });
}

/**
 * @description Search - Google Tag
 * Paste it in between the <head></head> tags of every page of your website.
 */
export function jsbSearchGtag() {
    $.getScript("https://www.googletagmanager.com/gtag/js?id=AW-11145896440", () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());

        gtag('config', 'AW-11145896440');

        gtag('event', 'conversion', { 'send_to': 'AW-11145896440/9eQxCKip3pcYEPjD48Ip' });

        // Search - Event Snippet - Page Load
        let anchor = document.querySelectorAll('a');
        anchor.forEach((a) => {
            a.addEventListener('click', () => {
                function gtag_report_conversion(url) {
                    var callback = function () {
                        if (typeof (url) != 'undefined') {
                            window.location = url;
                        }
                    };
                    gtag('event', 'conversion', {
                        'send_to': 'AW-11145896440/9eQxCKip3pcYEPjD48Ip',
                        'event_callback': callback
                    });
                    return false;
                }
            });
        });

        claimFormSubmit('gtag');

    });
}

/**
 * @description Meta Pixel
 * Paste the meta pixel into the bottom of the header section just above 
 * the </head> tag on every page of the website.
 */
export function jsbMetaPixels() {
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '821192670162302');
    fbq('track', 'PageView');

    claimFormSubmit('fbq');
}

/**
 * @description Twitter - Universal
 * Paste it before the </head> HTML tag of all pages on your website prior to adding event code (below).
 */
export function jsbTwitterUniversal() {
    !function (e, t, n, s, u, a) {
        e.twq || (s = e.twq = function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        }, s.version = '1.1', s.queue = [], u = t.createElement(n), u.async = !0, u.src = 'https://static.ads-twitter.com/uwt.js',
            a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a))
    }(window, document, 'script');
    twq('config', 'o7f0u');

    twq('event', 'tw-o7f0u-ong0s', {});

    claimFormSubmit('twq');
}

/**
 * @description Claim form submit button function
 */
function claimFormSubmit(trackingCode) {

    let getForm = document.querySelector("#form");
    let getSubmit = document.querySelector("#submit-claim");

    if (getForm && getSubmit) {
        getSubmit.addEventListener('click', () => {
            switch (trackingCode) {
                case 'fbq':
                    fbq('track', 'Lead');
                    break;
                case 'gtag':
                    gtag("event", "generate_lead", {
                        currency: "USD",
                        value: 1
                    });
                    break;
                case 'twq':
                    let conversion_id = Math.random().toString(36).substring(7);
                    twq('event', 'tw-o7f0u-ong0u', {
                        conversion_id: conversion_id
                    });
                    break;
                default:
                    break;
            }
        });
        return;
    }

    setTimeout(() => { claimFormSubmit(); }, 100);
}

console.log('jsb loaded');